var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9079 17.4167H17.9166M17.9079 17.4167C17.3371 17.9827 16.3026 17.8417 15.5772 17.8417C14.6867 17.8417 14.2579 18.0159 13.6224 18.6514C13.0813 19.1926 12.3558 20.1667 11.4999 20.1667C10.644 20.1667 9.91858 19.1926 9.37744 18.6514C8.74193 18.0159 8.31312 17.8417 7.42264 17.8417C6.69721 17.8417 5.66275 17.9827 5.09195 17.4167C4.51658 16.8461 4.65818 15.8074 4.65818 15.0773C4.65818 14.1546 4.4564 13.7304 3.79935 13.0733C2.82196 12.096 2.33327 11.6072 2.33325 11C2.33326 10.3927 2.82195 9.90404 3.79932 8.92667C4.38585 8.34014 4.65818 7.75893 4.65818 6.92273C4.65818 6.19727 4.5172 5.16281 5.08325 4.592C5.65381 4.01664 6.69255 4.15825 7.42266 4.15825C8.25883 4.15825 8.84005 3.88594 9.42656 3.29943C10.404 2.32204 10.8926 1.83334 11.4999 1.83334C12.1072 1.83334 12.5959 2.32204 13.5732 3.29943C14.1596 3.88582 14.7408 4.15825 15.5772 4.15825C16.3026 4.15825 17.3372 4.01727 17.908 4.58334C18.4833 5.1539 18.3416 6.19263 18.3416 6.92273C18.3416 7.84538 18.5435 8.2696 19.2005 8.92667C20.1779 9.90404 20.6666 10.3927 20.6666 11C20.6666 11.6072 20.1779 12.096 19.2005 13.0733C18.5434 13.7304 18.3416 14.1546 18.3416 15.0773C18.3416 15.8074 18.4833 16.8461 17.9079 17.4167Z",
    stroke: "#287D3C",
    strokeWidth: 1.125
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 11.8185C8.75 11.8185 9.85 12.416 10.4 13.2917C10.4 13.2917 12.05 9.85418 14.25 8.70834",
    stroke: "#287D3C",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.346346810538f7a6171f1d6a7e83b53b.svg";
export { ForwardRef as ReactComponent };